export default "/_next/static/images/massage-86dcc3bf2aeca2860dcbe66fdfb1e3a9.png";